import $ from 'jquery';

$(() => {

	// force footer links to be title case

	$('.footer__bottom .menu a').each((index, el) => {
		const parts = el.innerText.split(' ').map(str => {
			let titled = str.toLowerCase();
			titled = titled.substr(0, 1).toUpperCase() + titled.substr(1);
			return titled;
		});
		el.innerText = parts.join(' ');
	});

});